export enum Language {
  ENG = 'English',
  GRE = 'Greek',
  HEB = 'Hebrew',
  ARA = 'Arabic',
  RUS = 'Russian',
  GER = 'German',
  HUN = 'Hungarian',
  ITA = 'Italian'
}
